import { useEffect, useState } from "react";
import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";
import ImportAction from "../../Actions/ImportAction";
import Import_constants from "../../Constants/ImportConstants";
import importExcelStore from "../../Stores/ImportExcelStore";
import { useAlertWithButtonActionsContext } from "../../Context/AlertMessageContext";
import AlertWithButton from "../MessageBox/AlertWithButton";
import { useLanguageContext } from "../../Context/LanguageContext";
import { toast } from "react-toastify";
import { PageHeader } from "../MuiOverRideComponent/PageHeader";
import commonUtils from "../../helpers/commonUtils";

export default function ImportExcel(props) {
  const { localization } = useLanguageContext();
  const setAlertWithButton = useAlertWithButtonActionsContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const [importTypeList, setImportTypeList] = useState([]);
  const [importTypeID, setImportTypeID] = useState("");
  const [fileName, setFileName] = useState("");
  const [updateTemplate, setUpdateTemplate] = useState(false);
  const [data, setData] = useState({
    dropDepth: 0,
    inDropZone: false,
    fileList: [],
    filetoStringarray: [],
  });
  const [byDefault, setByDefault] = useState("downLoad");
  const [countDropDown, setCountDropDown] = useState([]);
  const [dropDownSelValue, setdropDownSelValue] = useState("");
  const [templateExcel, setTemplateExcel] = useState("");
  const [selectedValues, setSelectedValues] = useState("");
  const [showAction, setShowAction] = useState(false);
  const [alertHanlder, setalertHanlder] = useState();
  const [buildApilist, setBuildApilist] = useState(null);
  const [instMsg, setInstMsg] = useState("");

  useEffect(() => {
    setFileName("");
  }, [byDefault]);

  useEffect(() => {
    setGlobalSpinner(true);
    ImportAction.getImportTypes();
  }, []);

  useEffect(() => {
    if (commonUtils.isAdmin() && !updateTemplate) {
      setImportTypeID("Equipment");
    }
    return () => {};
  }, [updateTemplate]);

  useEffect(() => {
    if (importTypeID !== "") {
      setBuildApilist(null);
      setByDefault("downLoad");
      setFileName("");
      setSelectedValues("");
      setShowAction("");
      setInstMsg("");
      setCountDropDown([]);
      setdropDownSelValue();
      setGlobalSpinner(true);
      ImportAction.getImportConfig(importTypeID);
    }
  }, [importTypeID]);

  useEffect(() => {
    function getImportConfigSuccess() {
      var res = importExcelStore.getImportConfigResult();
      if (res) {
        let _item = [];
        let dropDownSelFieldValue = [];
        if (res.dropDownList !== null) {
          res.dropDownList.map((item, i) => {
            const itemName = item.toLowerCase();
            const dropDownName = itemName + `${i + 1}`;
            let tempArr = [];
            if (res[itemName] && itemName === "werks") {
              if (
                importTypeID == "EquipmentGroup" ||
                importTypeID == "User" ||
                importTypeID == "CostCenter" ||
                importTypeID == "Building"
              ) {
                tempArr = res[itemName].filter((item) => item.roleId !== 3);
              }
            }

            _item.push({
              itemName: item,
              list: tempArr.length > 0 ? tempArr : res[itemName],
            });
            dropDownSelFieldValue.push({
              [dropDownName]: "",
            });
          });

          setBuildApilist(res.dropDownList);
          setdropDownSelValue(dropDownSelFieldValue);
          setCountDropDown(_item);
          setInstMsg(res.instructions);
        } else {
          setCountDropDown([]);
          setBuildApilist(null);
          setdropDownSelValue(dropDownSelFieldValue);
        }
        setShowAction(true);
      } else {
        setCountDropDown([]);
        setShowAction(true);
      }
      setGlobalSpinner(false);
    }
    function getImportConfigFailure() {
      var res = importExcelStore.getImportConfigResult();
      toast.error(res);
      setGlobalSpinner(false);
    }
    importExcelStore.addChangeListener(
      Import_constants.GET_IMPORT_CONFIG_ON_ID_SUCCESS,
      getImportConfigSuccess,
    );
    importExcelStore.addChangeListener(
      Import_constants.GET_IMPORT_CONFIG_ON_ID_FAILURE,
      getImportConfigFailure,
    );
    return () => {
      importExcelStore.removeChangeListener(
        Import_constants.GET_IMPORT_CONFIG_ON_ID_SUCCESS,
        getImportConfigSuccess,
      );
      importExcelStore.removeChangeListener(
        Import_constants.GET_IMPORT_CONFIG_ON_ID_FAILURE,
        getImportConfigFailure,
      );
    };
  }, [importTypeID]);
  /* <>--------------------------------------------------------------------Get ImportType Start----------------------------------------------------------<> */
  useEffect(() => {
    function getImportTypeSuccess() {
      var res = importExcelStore.getImportExcelResult();
      if (res.length > 0) {
        setImportTypeList(res);
      } else {
        setImportTypeList([]);
      }
      setGlobalSpinner(false);
    }
    function getImportTypeFailure() {
      setGlobalSpinner(false);
    }
    importExcelStore.addChangeListener(
      Import_constants.GET_IMPORT_TYPE_SUCCESS,
      getImportTypeSuccess,
    );
    importExcelStore.addChangeListener(
      Import_constants.GET_IMPORT_TYPE_FAILURE,
      getImportTypeFailure,
    );
    return () => {
      importExcelStore.removeChangeListener(
        Import_constants.GET_IMPORT_TYPE_SUCCESS,
        getImportTypeSuccess,
      );
      importExcelStore.removeChangeListener(
        Import_constants.GET_IMPORT_TYPE_FAILURE,
        getImportTypeFailure,
      );
    };
  }, []);

  /* <>--------------------------------------------------------------------Get ImportType End----------------------------------------------------------<> */

  /* <>--------------------------------------------------------------------RenderDropDown Start----------------------------------------------------------<> */
  const handledropChange = (event, pos) => {
    let _itemvalues = { ...dropDownSelValue };
    const name = event.target.name;
    const value = event.target.value;
    _itemvalues[pos][name] = value;
    setdropDownSelValue(_itemvalues);
  };

  useEffect(() => {
    const _renderME = countDropDown.map((item, i) => {
      const dropDownName = item.itemName.toLowerCase() + `${i + 1}`;
      return (
        <>
          <div className="col" key={i}>
            <div className="form-group">
              <label htmlFor="equipmentGrp">{item.itemName}</label>
              <select
                className="form-control"
                id={dropDownName}
                name={dropDownName}
                value={dropDownSelValue[i][dropDownName]}
                onChange={(e) => {
                  e.preventDefault();

                  handledropChange(e, i);
                }}
              >
                <option value="" disabled>
                  {localization.select}
                </option>
                {item.list.map((row, index) => {
                  return (
                    <option key={index} value={row.id}>
                      {row.bezeichnung}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>
        </>
      );
    });
  }, [countDropDown, dropDownSelValue]);

  /* <>--------------------------------------------------------------------RenderDropDown End----------------------------------------------------------<> */

  /* <>--------------------------------------------------------------------Get Template End----------------------------------------------------------<> */

  useEffect(() => {
    if (templateExcel !== "") {
      const fileData = templateExcel.fileData;
      const contentType = templateExcel.fileType;
      const fileName = templateExcel.fileName;
      const blob = new Blob([base64ToArrayBuffer(fileData)], {
        type: contentType,
      });
      const url = window.URL.createObjectURL(blob);
      let a = document.createElement("a");

      a.hidden = "";
      a.href = url;
      a.download = fileName;
      a.click();
      setGlobalSpinner(false);
    }

    return () => {};
  }, [templateExcel]);

  useEffect(() => {
    function getTemplateSuccess() {
      var res = importExcelStore.getTemplateResult();
      setTemplateExcel(res);
    }
    function getTemplateFailure() {
      var res = importExcelStore.getTemplateResult();
      toast.error(res);
      setGlobalSpinner(false);
    }
    importExcelStore.addChangeListener(
      Import_constants.GET_IMPORT_TEMPLATE_SUCCESS,
      getTemplateSuccess,
    );
    importExcelStore.addChangeListener(
      Import_constants.GET_IMPORT_TEMPLATE_FAILURE,
      getTemplateFailure,
    );

    return () => {
      importExcelStore.removeChangeListener(
        Import_constants.GET_IMPORT_TEMPLATE_SUCCESS,
        getTemplateSuccess,
      );
      importExcelStore.removeChangeListener(
        Import_constants.GET_IMPORT_TEMPLATE_FAILURE,
        getTemplateFailure,
      );
    };
  }, []);

  /* <>--------------------------------------------------------------------Get Template End----------------------------------------------------------<> */

  /* <>--------------------------------------------------------------------Upload Template Data Start----------------------------------------------------------<> */

  useEffect(() => {
    function getTemplateDataUploadSuccess() {
      var res = importExcelStore.getUploadDataResult();
      if (res.fileData === null) {
        toast.success(localization.importSucees);
      } else {
        setalertHanlder({
          message: res.message,
          _func: partailImport,
        });
        setAlertWithButton(true);
      }
      setGlobalSpinner(false);
    }

    function getTemplateDataUploadFailure() {
      var res = importExcelStore.getUploadDataResult();
      toast.error(res);
      setGlobalSpinner(false);
    }

    importExcelStore.addChangeListener(
      Import_constants.UPLOAD_TEMPLATE_DATA_SUCCESS,
      getTemplateDataUploadSuccess,
    );

    importExcelStore.addChangeListener(
      Import_constants.UPLOAD_TEMPLATE_DATA_FAILURE,
      getTemplateDataUploadFailure,
    );

    return () => {
      importExcelStore.removeChangeListener(
        Import_constants.UPLOAD_TEMPLATE_DATA_SUCCESS,
        getTemplateDataUploadSuccess,
      );

      importExcelStore.removeChangeListener(
        Import_constants.UPLOAD_TEMPLATE_DATA_FAILURE,
        getTemplateDataUploadFailure,
      );
    };
  }, []);

  /* <>--------------------------------------------------------------------Upload Template Data End----------------------------------------------------------<> */
  function handleOnchange(event) {
    var files = [...event.target.files];
    if (files && files.length > 0) {
      setFileName(files[0].name);
      let reader = new FileReader();
      reader.onload = () => {
        setData((prevState) => ({
          fileList: [],
          filetoStringarray: {
            filename: files[0].name,
            filecontent: reader.result,
            filetyp: files[0].type,
          },
          dropDepth: 0,
          inDropZone: false,
        }));
      };
      reader.onerror = () => {};
      reader.readAsDataURL(files[0]);
    }
  }

  function handleTemplateGet(event) {
    event.preventDefault();
    let obj;
    if (byDefault === "downLoad") {
      obj = buildApi(buildApilist, selectedValues[0], importTypeID, byDefault);
      obj.UpdateTempalte = updateTemplate;
      ImportAction.getTemplate(obj);
      setGlobalSpinner(true);
    } else {
      obj = buildApi(
        buildApilist,
        selectedValues[0],
        importTypeID,
        byDefault,
        data.filetoStringarray,
      );
      ImportAction.uploadData(obj);

      setGlobalSpinner(true);
    }
  }
  function handleColumnChange(columnIndex, selectedValue) {
    if (selectedValue !== "") {
      setSelectedValues((prevSelectedValues) => {
        const newSelectedValues = [...prevSelectedValues];
        newSelectedValues[columnIndex] = selectedValue;
        return newSelectedValues;
      });
    } else {
      setSelectedValues("");
    }
  }

  function partailImport() {
    setAlertWithButton(false);
    setTemplateExcel(importExcelStore.getUploadDataResult());
  }

  function labelName(_label) {
    switch (_label) {
      case "Anlagegruppes":
        return localization.equipmentGroup;
      case "Werks":
        return localization.plant;
    }
  }

  return (
    <>
      <div className="w-100" id="content">
        <div className="pt-4  d-flex justify-content-between">
          <PageHeader
            Title={localization.genSetting + " / " + localization.import}
          />

          <div className="d-flex justify-content-between"></div>
        </div>
        <form
          id="excelImport"
          autoComplete="off"
          class="ml-3"
          onSubmit={handleTemplateGet}
        >
          <div className="row mt-4">
            {byDefault === "downLoad" && (
              <div className="col pl-0 pr-0 actioButton dropDpwnWidth">
                <div className="form-group">
                  <label className="form-label" htmlFor="Operation">
                    {localization.operation}
                  </label>
                  <select
                    className="form-control"
                    style={{ minWidth: "200px" }}
                    id="Operation"
                    name="Operation"
                    required
                    value={updateTemplate}
                    onChange={(e) => {
                      setUpdateTemplate(
                        e.target.value == "true" ? true : false,
                      );
                    }}
                  >
                    <option value={false}>{localization.insertNewData}</option>
                    <option value={true}>
                      {localization.updateExistingData}
                    </option>
                  </select>
                </div>
              </div>
            )}

            <div className="col ml-3 pr-0 actioButton dropDpwnWidth">
              <div className="form-group">
                <label className="form-label" htmlFor="equipmentGrp">
                  {localization.importType}
                </label>
                <select
                  className="form-control"
                  style={{ minWidth: "200px" }}
                  id="ImportType"
                  name="ImportType"
                  required
                  value={importTypeID}
                  onChange={(e) => {
                    setImportTypeID(e.target.value);
                  }}
                >
                  <option value="" disabled>
                    {localization.select}
                  </option>
                  {commonUtils.isAdmin() && !updateTemplate
                    ? importTypeList
                        .filter((item) => item.id !== "EquipmentGroup")
                        .map((row, index) => {
                          return (
                            <option key={index} value={row.id}>
                              {row.text}
                            </option>
                          );
                        })
                    : importTypeList.map((row, index) => {
                        return (
                          <option key={index} value={row.id}>
                            {row.text}
                          </option>
                        );
                      })}
                </select>
              </div>
            </div>
            {countDropDown.map((item, index) => {
              return (
                <div className="col ml-3 pr-0 dropDpwnWidth" key={index}>
                  <div className="form-group">
                    <label
                      className="wordRap form-label"
                      htmlFor="equipmentGrp"
                    >
                      {labelName(item.itemName)}
                    </label>
                    <SelectDropdown
                      id={item.itemName}
                      selectedValues={selectedValues[index]}
                      options={item.list}
                      onChange={(e) =>
                        handleColumnChange(index, e.target.value)
                      }
                    />
                  </div>
                </div>
              );
            })}
            {showAction && (
              <>
                <div className="col actioButton text-center">
                  <label className="form-label">{localization.action}</label>
                  <div className="row align-items-center">
                    <div className="col form-group dropDpwnWidth">
                      <input
                        id="download"
                        type="radio"
                        name="actionSelection"
                        value="downLoad"
                        defaultChecked={byDefault === "downLoad"}
                        onChange={() => {
                          setByDefault("downLoad");
                        }}
                      />
                      <label className="form-label" for="download">
                        {" "}
                        {localization.download}
                      </label>
                    </div>
                    <div className="col dropDpwnWidth">
                      <input
                        id="upload"
                        type="radio"
                        name="actionSelection"
                        value="upload"
                        defaultChecked={byDefault === "Upload"}
                        onChange={() => {
                          setByDefault("Upload");
                        }}
                      />
                      <label className="form-label" for="upload">
                        {localization.upload}
                      </label>
                    </div>
                  </div>
                </div>

                {byDefault === "downLoad" && (
                  <div className="col align-self-end">
                    <div className="form-group  pr-5">
                      <button
                        id="downLoad"
                        type="submit"
                        disabled={
                          countDropDown.length > 0
                            ? selectedValues === ""
                              ? true
                              : false
                            : false
                        }
                        className="btn btn-primary btn-block mb-2 actioButton"
                      >
                        {localization.download}
                      </button>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
          {byDefault === "Upload" && (
            <>
              <div className="row m">
                <div className="form-group">
                  <label
                    className="btn btn-primary mt-2"
                    onChange={handleOnchange}
                  >
                    <span
                      className="glyphicon glyphicon-paperclip"
                      aria-hidden="false"
                    ></span>{" "}
                    {localization.browse}
                    <input
                      type="file"
                      id="file"
                      disabled={false}
                      multiple
                      hidden
                    />
                  </label>
                </div>
              </div>
              <div className="row">
                <div className="col pl-0 pr-0">
                  <input
                    id="SelectedFileName"
                    className="form-control"
                    type="text"
                    name="SelectedFileName"
                    value={fileName}
                    readOnly
                  />
                </div>
                <div className="col">
                  <button
                    disabled={fileName === ""}
                    className="btn btn-primary btn-block mb-4 actioButton"
                  >
                    {localization.upload}
                  </button>
                </div>
              </div>
            </>
          )}
        </form>
        <AlertWithButton handler={alertHanlder} />
      </div>
      <div className="instructions">
        <h1>{localization.instructionsHead}</h1>
        <ul>
          <li>{localization.msgRow1}</li>
          <li>{localization.msgRow2}</li>
          <li>{localization.msgRow3}</li>
          <li>{localization.msgRow4}</li>
          <li>{localization.msgRow5}</li>
          <li>{localization.msgRow6}</li>
        </ul>
        {instMsg !== "" && instructions(instMsg)}
      </div>
    </>
  );
}

function SelectDropdown({ id, selectedValues, options, onChange }) {
  const { localization } = useLanguageContext();
  return (
    <select
      id={id}
      onChange={onChange}
      value={selectedValues}
      required
      className="form-control"
    >
      <option value="">{localization.select}</option>
      {options.map((option) => (
        <option key={option.id} value={option.id}>
          {option.bezeichnung}
        </option>
      ))}
    </select>
  );
}

function base64ToArrayBuffer(base64) {
  const binaryString = window.atob(base64);
  const byteArray = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    byteArray[i] = binaryString.charCodeAt(i);
  }
  return byteArray;
}

function buildApi(typeDropDown, selected, importTypeID, byDefault, importFile) {
  if (typeDropDown !== null) {
    if (byDefault === "downLoad") {
      switch (typeDropDown[0]) {
        case "Anlagegruppes":
          return {
            ImportType: importTypeID,
            EquipmentGroupId: selected,
          };
        case "Werks":
          return {
            ImportType: importTypeID,
            WerkId: selected,
          };
      }
    } else {
      switch (typeDropDown[0]) {
        case "Anlagegruppes":
          return {
            ImportType: importTypeID,
            EquipmentGroupId: selected,
            ImportFile: importFile,
          };
        case "Werks":
          return {
            ImportType: importTypeID,
            WerkId: selected,
            ImportFile: importFile,
          };
      }
    }
  } else {
    if (byDefault === "downLoad") {
      return {
        ImportType: importTypeID,
      };
    } else {
      return {
        ImportType: importTypeID,
        ImportFile: importFile,
      };
    }
  }
}

function instructions(_msg) {
  const msgArray = _msg.split(".");
  msgArray.pop();
  const msgFormate = (
    <ul className="p-5 seconDiv">
      {msgArray.map((item, index) => (
        <li key={index}>{item}</li>
      ))}
    </ul>
  );
  return msgFormate;
}
